<template>
  <v-card
    v-if="loading || (promotions != null && promotions.length > 0)"
    id="promotions"
    flat
    tile
    width="100%"
    height="100vh"
    color="primary"
  >
    <!-- Skeleton loader -->
    <section v-if="loading">
      <v-skeleton-loader />
    </section>

    <!-- Contents if exist after being loadded -->
    <section v-else>
      <div class="main" id="main">
        <transition name="fade-img">
          <img
            v-if="!isMobile"
            :src="promotions[currentID].PictureUrl"
            :key="imageKey"
            ref="promoImg"
            @load="handleImageLoaded"
            width="auto"
            height="100%"
          />
          <img
            v-if="isMobile"
            :src="
              promotions[currentID].PortraitPictureUrl !== ''
                ? promotions[currentID].PortraitPictureUrl
                : promotions[currentID].PictureUrl
            "
            :key="imageKey"
            ref="promoImgPortrait"
            @load="handleImageLoaded"
            width="100%"
            height="100%"
          />
        </transition>
        <transition name="fade-veil">
          <v-card
            v-if="showImageVeil"
            class="white--text veil"
            tile
            flat
            color="rgba(0, 0, 0, 0.3)"
          >
            <v-container fill-height>
              <v-row class="ma-0" justify="center">
                <v-col align="center">
                  <!-- Title -->
                  <div class="promotionName font-weight-bold text-truncate">
                    {{ promotions[currentID].Name }}
                  </div>

                  <!-- Subtitle -->
                  <div
                    class="promotionSubtitle word-break-normal py-6"
                    v-html="promotions[currentID].Subtitle"
                  />
                  <!-- Button to create subscription -->
                  <v-btn
                    fixed
                    rounded
                    large
                    color="secondary"
                    class="view-button mb-4"
                    @click.stop="onPromotionSelected"
                  >
                    <span v-html="$translate('VIEW')"></span>
                  </v-btn>
                  <!-- url button -->
                  <v-row justify="center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="
                            partnerGroupDetails.InfoUrl !== null &&
                            partnerGroupDetails.InfoUrl !== ''
                          "
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          class="rounded-pill pa-2 pa-md-6"
                          style="font-size: 22px"
                          @click.stop="openUrl(partnerGroupDetails.InfoUrl)"
                        >
                          {{ partnerGroupDetails.InfoUrlName }}
                        </v-btn>
                      </template>
                      <span>{{ $translate('SHOW_URL') }}</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </transition>
      </div>
    </section>
   <v-card
     style="
       z-index: 100;
       position: absolute;
       left: 2%;
       bottom: 5%;
       max-width: 25%;
     "
     v-if="!userLoggedIn && !isMobile"
     color="transparent"
     flat
     class="mt-6 px-5 pt-4 pb-4 text-container"
   >
     <div class="primary-font-color banner-subtitle word-break-normal">
       {{ partner.BannerSubTitle }}
     </div>
     <div class="primary-font-color banner-title font-weight-medium">
       {{ partner.BannerPromise }}
     </div>
     <div
       class="primary-font-color banner-description mt-2"
       v-html="partner.BannerDescription"
     ></div>
     <v-form ref="form" v-model="valid">
       <v-text-field
         class="pa-0 email-input"
         :rules="emailRules"
         v-model="email"
         dark
         required
         :color="primaryFontColor"
         :label="$translate('LOGIN_YOUR_EMAIL')"
       >
       </v-text-field>
     </v-form>

     <v-row justify="center" class="my-0">
       <v-btn
         depressed
         dark
         color="secondary"
         class="secondary-font-color ma-0 font-weight-bold"
         @click="importInterestedUser"
       >
         {{ $translate('NEWS_LETTER_BUTTON') }}
       </v-btn>
     </v-row>
</v-card>
<v-card
        justify-end
        v-if="isMobile && !userLoggedIn"
        style="position: absolute; bottom: 0%;"
        flat
        color="transparent"
      >
        <v-card flat tile class="text-container overlay-card-small px-4 py-2">
          <v-row class="ma-0">
            <v-col class="pa-0">
              <h4
                class="primary-font-color word-break-normal font-weight-regular banner-subtitle-sm"
              >
                {{ partner.BannerSubTitle }}
              </h4>
              <v-col class="pa-0">
                <v-row class="ma-0">
                  <v-col class="pa-0" cols="12">
                    <h3
                      class="primary-font-color font-weight-medium banner-title-sm"
                    >
                      {{ partner.BannerPromise }}
                    </h3>
                  </v-col>
                  <v-col>
                  <v-form ref="form">
                    <v-text-field
                      class="pa-0 email-input"
                      :rules="emailRules"
                      v-model="email"
                      dark
                      required
                      :color="primaryFontColor"
                      :label="$translate('LOGIN_YOUR_EMAIL')"
                    />
                  </v-form>
                  </v-col>
                  <v-col class="pa-0 text-right" cols="4">
                    <v-btn
                      style="z-index: 0;"
                      depressed
                      width="100px"
                      dark
                      color="secondary"
                      class="secondary-font-color ma-0 font-weight-bold"
                      @click="importInterestedUser"
                    >
                      <span
                        v-html="$translate('NEWS_LETTER_BUTTON_HTML')"
                      ></span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-card> 
      </v-card>
  </v-card>
</template>

<script>
import { addLog } from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';
import utility from '@/shared/utility';
import doRequest from '@/api/dssRequest';
import appConfig from '../../../config/app_config';

export default {
  name: 'PromotionsViewPromotions',
  mixins: [uiHelpers],
  computed: {
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    partnerGroupDetails() {
      const details = this.$store.getters['Account/partnerGroupDetails'];
      if (details == null) {
        return {};
      }
      return details;
    },
    loading() {
      return this.$store.getters['user/loadingPromotions'];
    },
    promotions() {
      const showPromotionsOnHomepage = [];
      const allPromotions = this.$store.getters['user/promotions'];
      allPromotions.forEach((promotion) => {
        if (promotion.VisibleOnHomepage) {
          showPromotionsOnHomepage.push(promotion);
        }
      });
      return showPromotionsOnHomepage;
    },
    userObject() {
      return this.$store.getters['auth/userObjectId'];
    },
    primaryFontColor() {
      return this.$store.getters['Account/partnerGroupDetails']
        .PrimaryFontColor;
    },
  },
  data() {
    return {
      currentID: 0,
      imageKey: -1, // Used to trigger a redraw in <img>
      showImageVeil: false,
      timer: null,
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
      email: '',
      partner: {},
    };
  },
  mounted() {
    this.partner = this.$store.getters['Account/partnerGroupDetails'];
    this.initPrimaryColorWithOpacity();

    this.timer = setInterval(() => {
      this.toggleImage();
    }, 7000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    openUrl(url) {
      const fullUrl = utility.getFullUrl(url);
      window.open(fullUrl);
    },
    initPrimaryColorWithOpacity() {
      const opacityHexValue = 'CC';
      const selector = document.querySelector(':root');
      selector.style.setProperty(
        '--primary-color-opacity',
        `${this.$vuetify.theme.themes.light.primary}${opacityHexValue}`
      );
    },
    importInterestedUser() {
      // check if email field is filled in
      if (!this.$refs.form.validate()) {
        return;
      }
      const payload = {
        Email: this.email,
        client_id: appConfig.Userlogin.clientSecret,
        TempUserId: this.$store.getters['auth/tmpUserId'],
      };
      doRequest(
        (response) => {
          // change the temp user id
          this.$store.commit('auth/setTmpUserId', response.data.UserId);
          this.$refs.form.reset();
          if (response.data.UserExisted) {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('NEWSLETTER_ALERT_USEREXISTED')
            );
          } else {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('NEWSLETTER_ALERT_SUCCESS')
            );
          }
        },
        () => {
          window.EventBus.fire(
            'activateSnackBar',
            this.$translate('NEWSLETTER_ALERT_ERROR')
          );
        },
        'importInterestedUser',
        this.$store.getters['Account/partnerGroupDetails'].AccountId,
        payload
      );
    },
    handleImageLoaded() {
      // First time we load an image, the imageKey doesn't have the same value as the currentID. So, the key on the <img> will change
      // and trigger a redraw, which will trigger a recalculate of the imageSize.
      if (!this.showImageVeil) {
        setTimeout(() => {
          this.showImageVeil = true;
        }, 1000);
      }
      this.imageKey = this.currentID;
    },
    imageSize() {
      if (this.$refs.promoImg == undefined) {
        let width = undefined;
        let height = undefined;
        return { width, height };
      }
      const vw = this.$vuetify.breakpoint.width;
      const vh = this.$vuetify.breakpoint.height;
      var width = this.$refs.promoImg.naturalWidth;
      var height = this.$refs.promoImg.naturalHeight;
      const aspectRatio = width / height;

      width = vw;
      height = width / aspectRatio;

      if (height < vh) {
        height = vh;
        width = height * aspectRatio;
      }

      return { width, height };
    },
    toggleImage() {
      this.showImageVeil = false;
      if (this.currentID < this.promotions.length - 1) {
        this.currentID += 1;
      } else {
        this.currentID = 0;
      }
      this.imageKey = this.currentID;
    },
    onPromotionSelected() {
      // Add user interaction to log
      addLog(
        this.userObject,
        this.promotions[this.currentID].EventId,
        'Event',
        'Home',
        -1
      );
      // Go to event details screen
      this.goToPage('EventDetails', {
        event_id: this.promotions[this.currentID].EventId,
      });
    },
  },
};
</script>

<style scoped lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@700&display=swap');
//@import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@1,300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:ital@1&display=swap');

main {
  position: absolute;
}
img {
  position: absolute;
  transition: all 2s ease;
  width: auto;
  @media only screen and (min-width: 1025px) {
    width: 100%;
  }
}

.veil {
  position: relative;
  width: 100vw;
  height: 100vh;
  transition: all 2s ease;
}

button {
  z-index: 100;
  position: relative;
  width: 200px;
  height: 25px;
  margin: 20px;
}

.fade-img-enter-to {
  opacity: 1;
}
.fade-img-enter {
  opacity: 0;
}

.fade-veil-enter-to {
  opacity: 1;
}

.fade-veil-enter {
  opacity: 0;
}
.view-enter-active {
  transition-delay: 2s;
}
.fade-veil-leave-to {
  opacity: 0;
}

.promotionName {
  font-size: 28px;
  line-height: 36 px;
  font-family: Nunito;
  font-weight: 800;

  @media only screen and (min-width: 964px) {
    font-size: 44px;
    line-height: 50px;
  }
}
.promotionSubtitle {
  font-size: 20px;
  line-height: 24px;
  max-width: 80%;
  font-family: Nunito;
  font-weight: 400;
  font-style: italic;
  letter-spacing: 0.5px;
  @media only screen and (min-width: 964px) {
    font-size: 24px;
    line-height: 27px;
  }
}
.view-button {
  font-size: 22px;
  color: var(--secondary-font-color) !important;
  @media only screen and (max-width: 964px) {
    font-size: 18px;
  }
}
.email-input::v-deep .v-text-field__slot {
  & label {
    color: var(--primary-font-color) !important;
  }
  & input {
    color: var(--primary-font-color) !important;
  }
}
.email-input::v-deep .v-input__slot::before {
  border-color: var(--primary-font-color) !important;
}
.email-input-dialog::v-deep .v-text-field__slot {
  & label {
    color: black !important;
  }
  & input {
    color: black !important;
  }
}
.email-input-dialog::v-deep .v-input__slot::before {
  border-color: black !important;
}
.text-container {
  background-color: var(--primary-color-opacity) !important;
}
.banner-title {
  font-size: 25px;
  line-height: 30px;
}
.banner-title-sm {
  font-size: 0.9em;
  line-height: 1.2;
}
.banner-subtitle {
  font-size: 18px;
  line-height: 22px;
}
.banner-subtitle-sm {
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 2px;
}
.banner-description {
  font-size: 14px;
  line-height: 18px;
}
</style>
